/// <amd-module name="Search/Package/Components/Notification" />

import * as Resources from "Search/Package/Resources";
import { IndexingBanner } from "Search/Package/Flux/Stores/NotificationStore";
import { IAggregatedState } from "Search/Package/Flux/StoresHub";
import { ActionCreator } from "Search/Package/Flux/ActionCreator";
import { ObservableValue } from "VSS/Core/Observable";
import { INotificationProps } from "Search/Shared/Components/NotificationArea";
import { MessageBarSeverity } from "VSSUI/MessageBar";

export function handlePivotNotification(
    pageNotification: ObservableValue<INotificationProps>,
    getAggregatedState: () => IAggregatedState,
    actionCreator: ActionCreator) {
    const { notificationStoreState } = getAggregatedState();
    const { indexingBannerState } = notificationStoreState;
    const { publishNotificationBanner, dismissNotificationBanner } = actionCreator;
    const message =
        indexingBannerState === IndexingBanner.AccountIndexing
            ? Resources.AccountIsGettingIndexedBannerMessage
            : "";

    if (message) {
        // Handle indexing scenarios
        pageNotification.value = {
            visible: true,
            isFormatted: false,
            severity: MessageBarSeverity.Warning,
            message,
            onDismiss: dismissNotificationBanner
        }

        publishNotificationBanner(IndexingBanner[notificationStoreState.indexingBannerState]);
    } else {
        // dispose notification if none of indexing is in progress notifications are obtained.
        pageNotification.value = {
            ...pageNotification.value,
            visible: false
        }
    }
}